export default "__VITE_ASSET__CpYTQuFU__"